import { useCustomMutation } from "@refinedev/core";
import { InvoiceResponse } from "@/types";
import { useSession } from "hooks/useSession/";

interface UpdateSubscriptionParams {
  subscriptionId: string;
  subscriptionItemId: string;
  priceId: string;
  quantity: number;
}

interface UpdateSubscriptionResponse {
  invoice?: InvoiceResponse;
}

export function useUpdateSubscription() {
  const { currentOrganization: organization } = useSession();
  const { mutateAsync, isPending, error } =
    useCustomMutation<UpdateSubscriptionResponse>();

  const updateSubscription = async ({
    subscriptionId,
    subscriptionItemId,
    priceId,
    quantity,
  }: UpdateSubscriptionParams) => {
    if (!organization?.id) throw new Error("Organization not found");

    return mutateAsync({
      url: `api/organizations/${organization.id}/payments/${subscriptionId}`,
      method: "patch",
      values: {
        subscription_item_id: subscriptionItemId,
        price_id: priceId,
        quantity,
      },
      successNotification: false,
      errorNotification: false,
    });
  };

  return {
    updateSubscription,
    isPending,
    error,
  };
}
